export enum EStatus {
  NEW = 'NEW',
  PUBLISHED = 'PUBLISHED',
  DELETED = 'DELETED',
  CANCELED = 'CANCELED',
  REJECTED = 'REJECTED',
}
